import React from 'react';
import { Box, CircularProgress, LinearProgress, Typography, useTheme, Tooltip } from '@mui/material';

// Helper function to determine color based on score
const getScoreColor = (score) => {
  if (score >= 0.75) return "success";
  if (score >= 0.5) return "info";
  if (score >= 0.25) return "warning";
  return "error";
};

const ScoreIndicator = ({ score, type = 'linear', tooltipTitle }) => {
  const theme = useTheme();
  const normalizedScore = Math.min(Math.max(score || 0, 0), 1);
  const percentage = Math.round(normalizedScore * 100);
  const color = getScoreColor(normalizedScore);

  let content;

  if (type === 'radial') {
    content = (
      <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={32}
          thickness={4}
          color={color}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary" sx={{ fontWeight: 'bold' }}>
            {`${percentage}`}
          </Typography>
        </Box>
      </Box>
    );
  } else {
    content = (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          color={color}
          sx={{ width: '100%', height: 6, borderRadius: 3 }}
        />
        <Typography variant="body2" sx={{ fontWeight: 500, color: `${color}.main`, minWidth: '35px' }}>
          {percentage}%
        </Typography>
      </Box>
    );
  }

  // If a tooltipTitle is provided, wrap the content in a Tooltip component
  if (tooltipTitle) {
    return (
      <Tooltip title={tooltipTitle} arrow placement="top">
        {/* The span is important for the tooltip to correctly anchor to the content */}
        <span>
          {content}
        </span>
      </Tooltip>
    );
  }

  return content;
};

export default ScoreIndicator;